import React from "react";
import { Text } from "mondrian-react";
import Button from "components/Button";
import styled from "styled-components";
export const Strong = styled.strong`
  font-weight: bold;
`;
export const Warning = styled.strong`
  display: flex;
`;
export const Resend = styled.button`
  text-decoration: underline;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font: inherit;
  font-weight: bold;
`;

const Content = ({ associated, ...props }) => {
  const { status = "sem-status" } = associated;
  let content = "";
  function setFormNext(flux, payload = null) {
    switch (flux) {
      case "cancelInvite":
        props.setCustomData({ flux: "cancelInvite", ...associated, ...props });
        props.next("confirm");
        break;
      case "optOut":
        props.setCustomData({ flux: "selfremove", ...associated, ...props });
        props.next("confirm");
        break;
      case "resend":
        props.setCustomData({ flux: "resend", ...associated, ...props });
        props.next("confirm");
        break;
      case "remove":
        props.setCustomData({ flux: "remove", ...associated, ...props });
        props.next("confirm");
        break;
      case "add":
        props.setCustomData({ flux: "add", ...associated, ...props });
        props.next("inputDependenteCpf");
        break;
      default:
        break;
    }
  }
  if (props.isDependente) {
    content = (
      <>
        <Text>
          <Strong>Dados do Titular:</Strong>
        </Text>
        {associated.name && (
          <Text>
            <Strong>{associated.name}</Strong>
          </Text>
        )}
        {associated.email && (
          <Text>
            <Strong>Email: </Strong>
            {associated.email}
          </Text>
        )}
        {associated.cpfCnpj && (
          <Text>
            <Strong>CPF: </Strong> {associated.cpfCnpj}
          </Text>
        )}
        <br />
        <Button
          onClick={() => setFormNext("optOut", props.id)}
          type="button"
          secondary
          tabIndex={props.tabIndex}
        >
          Desvincular
        </Button>
      </>
    );
  } else if (status === "ATIVO") {
    content = (
      <>
        <Text>
          <Strong>Dependente</Strong>
        </Text>
        <br />
        {associated.name && (
          <Text>
            <Strong>{associated.name}</Strong>
          </Text>
        )}
        {associated.email && (
          <Text>
            <Strong>Email: </Strong>
            {associated.email}
          </Text>
        )}
        {associated.cpfCnpj && (
          <Text>
            <Strong>CPF: </Strong> {associated.cpfCnpj}
          </Text>
        )}
        {associated.birthday && (
          <Text>
            <Strong>Data de Nascimento: </Strong>
            {associated.birthday}
          </Text>
        )}
        <br />
        <Button
          onClick={() => setFormNext("remove", props.id)}
          type="button"
          secondary
          tabIndex={props.tabIndex}
        >
          Remover Dependente
        </Button>
      </>
    );
  } else if (associated.status === "PENDENTE") {
    content = (
      <>
        <Text>
          <Strong>Dependente</Strong>
        </Text>
        <br />
        <Text>
          <Warning className="warning-Text">
            <i className="mdn-Icon-informacoes mdn-Icon--md mdn-u-marginRight--xxxs"></i>
            O dependente escolhido para esta linha ainda não aceitou o seu
            convite.{" "}
            {!!props.resendTime ? (
              `O reenvio do convite estará disponível em ${props.resendTime} minutos.`
            ) : (
              <Resend
                className="mdn-Button--secondary btn-Resend"
                onClick={() => setFormNext("resend", props.id)}
              >
                Reenviar
              </Resend>
            )}
          </Warning>
        </Text>
        <br />
        <Button
          onClick={() => setFormNext("cancelInvite", props.id)}
          type="button"
          secondary
          tabIndex={props.tabIndex}
        >
          Cancelar Convite
        </Button>
      </>
    );
  } else if (associated.status === "DISPONIVEL" && props.eligible) {
    content = (
      <>
        <Button
          onClick={() => setFormNext("add", props.id)}
          type="button"
          tabIndex={props.tabIndex}
        >
          Adicionar Dependente
        </Button>
      </>
    );
  }
  return <>{content}</>;
};

const ContentText = ({ ...props }) => {
  if (!props.msisdn && !props.plano) return null;
  return (
    <>
      <div className="mdn-Row">
        <div className="mdn-Col-xs-12">
          <div className="mdn-Link mdn-Link--arrow">
            <span className="mdn-Accordion-toggle mdn-Text mdn-Text--body">
              <i className="cred-icon-correction mdn-Icon-celular mdn-Icon--md mdn-u-marginRight--xxs cred-no-animation"></i>
              {props.msisdn} (
              <Strong Style="font-weight: bold;">{props.segment}</Strong>)
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export { Content, ContentText };
